import React from 'react';
import Container from "../../../../components/Container";
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import styles from './Desktop.module.css';
import Loader from 'react-loader-spinner';
import ReactivatePopup from '../../components/ReactivatePopup';
import resyncImg from '../../../../assets/images/Fireboard/resync.png';

import { pass, fail } from '../../../../assets/images';

export default function Desktop(props) {
    const { tableData, popup, onPress, closePopup, history, isComponent, dismissPopup } = props;
    const { location } = history || {};
    const { state } = location || {};
    const themeColor = state?.themeColor || '#AD0028';

    const getIcon = result => {
        switch (result) {
            case 'pass': {
                return <div className={styles.result}>
                        <span className={styles.resultLabel}>Pass</span>  <img src={pass} alt="pass" className={styles.icon} /> 
                     </div>;
            }
            case 'fail': {
                return  <div className={styles.result}>
                            <span className={styles.resultLabel}>Fail</span>  <img src={fail} alt="fail" className={styles.icon} /> 
                        </div>;
            }
            default: {
                return <Loader
                    type="Oval"
                    color={themeColor}
                    height="20"
                    width="20"
                    style={{ marginRight: '10px', display:'flex', justifyContent:'center' }}
                />;
            }
        }
    };

    const getPopupStyle = () => {
        let popupStyle = { width: '27.41vw' };
        if (popup && popup.type === 'reactivate') {
            popupStyle = { width: '46.41vw', height: '30.97vh', padding: '1.78vh' };
        }
        else if (popup && popup.type === "spinner") {
            popupStyle = { width: "60%" };
        } 
        return popupStyle;
    }

    const getPopup = () => {
        if (!popup) return;

        switch (popup.type) {
            case 'reactivate':
                return <ReactivatePopup {...popup} onDone={onPress} themeColor={themeColor} />;
            default: {
                return <PopupContent {...popup} themeColor={themeColor} />;
            }
        }
    }

    const onClose = () => {
        if(isComponent) {
            dismissPopup && dismissPopup();
        } else {
            history.goBack();
        }
    };

    return (
        <Container style={styles.container}>
            <Popup visible={!!popup} popupStyle={getPopupStyle()} closePopup={closePopup}>
                {getPopup()}
            </Popup>
            <div className={styles.wrapper}>
                <div className={styles.diagnosticsContainer} style={{ border: `1px solid ${themeColor}` }}>
                    <div className={styles.header} style={{ backgroundColor: themeColor }}>
                     <img src={resyncImg} alt="pass" className={styles.reloadIcon} /> 
                        <span className={styles.heading}>Diagnostics</span>
                        <div className={styles.closeBtn} onClick={onClose} >X</div>
                    </div>
                    <div className={styles.bodyContainer}>
                        <table className={styles.tbl} cellPadding="5" cellSpacing="0">
                            <tbody>
                                <tr className={styles.rowHeader}>
                                    <th>Test</th>
                                    <th>Status</th>
                                    <th>Result</th>
                                </tr>
                                {tableData.map(data => {
                                    return (
                                        <tr key={data.id}>
                                            <td>{data.test}</td>
                                            <td>{data.value}</td>
                                            <td>{getIcon(data.result)}</td>
                                        </tr>
                                    )
                                })}
                                <tr className={styles.footer}>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className={styles.btnWrapper}>
                        <button className={styles.btns} style={{ backgroundColor: themeColor }} onClick={() => onPress('reactivate')}>Re-Activate</button>
                    </div>
                </div>
            </div>
        </Container>
    );
}